/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './equipment-allotment.reducer';

export const EquipmentAllotment = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const equipmentAllotmentList = useAppSelector(state => state.equipmentAllotment.entities);
  const loading = useAppSelector(state => state.equipmentAllotment.loading);
  const totalItems = useAppSelector(state => state.equipmentAllotment.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="equipment-allotment-heading" data-cy="EquipmentAllotmentHeading">
        <Translate contentKey="tinyMedicRestApp.equipmentAllotment.home.title">Equipment Allotments</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.equipmentAllotment.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/equipment-allotment/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.equipmentAllotment.home.createLabel">Create new Equipment Allotment</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.equipmentAllotment.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {equipmentAllotmentList && equipmentAllotmentList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.equipmentAllotment.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('allotmentDate')}>
                  <Translate contentKey="tinyMedicRestApp.equipmentAllotment.allotmentDate">Allotment Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('allotmentDate')} />
                </th>
                <th className="hand" onClick={sort('releaseDate')}>
                  <Translate contentKey="tinyMedicRestApp.equipmentAllotment.releaseDate">Release Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('releaseDate')} />
                </th>
                <th className="hand" onClick={sort('lastupdated')}>
                  <Translate contentKey="tinyMedicRestApp.equipmentAllotment.lastupdated">Lastupdated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastupdated')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.equipmentAllotment.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.equipmentAllotment.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('allotmentNotes')}>
                  <Translate contentKey="tinyMedicRestApp.equipmentAllotment.allotmentNotes">Allotment Notes</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('allotmentNotes')} />
                </th>
                <th className="hand" onClick={sort('allottedById')}>
                  <Translate contentKey="tinyMedicRestApp.equipmentAllotment.allottedById">Allotted By Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('allottedById')} />
                </th>
                <th className="hand" onClick={sort('releasedById')}>
                  <Translate contentKey="tinyMedicRestApp.equipmentAllotment.releasedById">Released By Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('releasedById')} />
                </th>
                <th className="hand" onClick={sort('allottedByType')}>
                  <Translate contentKey="tinyMedicRestApp.equipmentAllotment.allottedByType">Allotted By Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('allottedByType')} />
                </th>
                <th className="hand" onClick={sort('releasedByType')}>
                  <Translate contentKey="tinyMedicRestApp.equipmentAllotment.releasedByType">Released By Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('releasedByType')} />
                </th>
                <th className="hand" onClick={sort('quantity')}>
                  <Translate contentKey="tinyMedicRestApp.equipmentAllotment.quantity">Quantity</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('quantity')} />
                </th>
                <th className="hand" onClick={sort('allotmentType')}>
                  <Translate contentKey="tinyMedicRestApp.equipmentAllotment.allotmentType">Allotment Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('allotmentType')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.equipmentAllotment.admission">Admission</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.equipmentAllotment.equipment">Equipment</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.equipmentAllotment.appointment">Appointment</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.equipmentAllotment.equipmentCharge">Equipment Charge</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {equipmentAllotmentList.map((equipmentAllotment, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/equipment-allotment/${equipmentAllotment.id}`} color="link" size="sm">
                      {equipmentAllotment.id}
                    </Button>
                  </td>
                  <td>{equipmentAllotment.allotmentDate}</td>
                  <td>{equipmentAllotment.releaseDate}</td>
                  <td>{equipmentAllotment.lastupdated}</td>
                  <td>{equipmentAllotment.cursor}</td>
                  <td>{equipmentAllotment.active ? 'true' : 'false'}</td>
                  <td>{equipmentAllotment.allotmentNotes}</td>
                  <td>{equipmentAllotment.allottedById}</td>
                  <td>{equipmentAllotment.releasedById}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.AllottedByType.${equipmentAllotment.allottedByType}`} />
                  </td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.AllottedByType.${equipmentAllotment.releasedByType}`} />
                  </td>
                  <td>{equipmentAllotment.quantity}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.PatientType.${equipmentAllotment.allotmentType}`} />
                  </td>
                  <td>
                    {equipmentAllotment.admission ? (
                      <Link to={`/admission/${equipmentAllotment.admission.id}`}>{equipmentAllotment.admission.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {equipmentAllotment.equipment ? (
                      <Link to={`/equipment-ip/${equipmentAllotment.equipment.id}`}>{equipmentAllotment.equipment.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {equipmentAllotment.appointment ? (
                      <Link to={`/appointments/${equipmentAllotment.appointment.id}`}>{equipmentAllotment.appointment.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {equipmentAllotment.equipmentCharge ? (
                      <Link to={`/equipment-ip-charges/${equipmentAllotment.equipmentCharge.id}`}>
                        {equipmentAllotment.equipmentCharge.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/equipment-allotment/${equipmentAllotment.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/equipment-allotment/${equipmentAllotment.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/equipment-allotment/${equipmentAllotment.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.equipmentAllotment.home.notFound">No Equipment Allotments found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={equipmentAllotmentList && equipmentAllotmentList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default EquipmentAllotment;
